import {Controller, useFormContext} from "react-hook-form";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {Select, Space} from "antd";
import {BundleSessionSessionPeriodNumberOfSessionFormFieldType} from "./types";

export const bundleSessionOptions = [
  {
    label: "2 sessions",
    value: 2,
  },
  {
    label: "3 sessions",
    value: 3,
  },
  {
    label: "4 sessions",
    value: 4,
  },
  {
    label: "5 sessions",
    value: 5,
  },
  {
    label: "6 sessions",
    value: 6,
  },
  {
    label: "7 sessions",
    value: 7,
  },
  {
    label: "8 sessions",
    value: 8,
  },
  {
    label: "9 sessions",
    value: 9,
  },
  {
    label: "10 sessions",
    value: 10,
  },
];

export function BundleSessionSessionPeriodNumberOfSessionFormField() {
  const {control} =
    useFormContext<BundleSessionSessionPeriodNumberOfSessionFormFieldType>();

  return (
    <div>
      <FormField
        id={"bundleNumberOfSession"}
        label={"Number of sessions"}
        renderInput={(id) => (
          <Controller
            control={control}
            name="numberOfSessions"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space direction="vertical" size={16} style={{display: "flex"}}>
                <Select
                  id={id}
                  size="large"
                  status={error?.message ? "error" : undefined}
                  style={{width: "100%"}}
                  onChange={onChange}
                  value={value}
                  ref={ref}
                  onBlur={onBlur}
                  options={bundleSessionOptions}
                  placeholder={"Please select"}
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      />
    </div>
  );
}
